import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import English translations only
import translationEN from './locales/en.json';

// Initialize i18n with English only
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
    },
    lng: 'en', // Always use English
    fallbackLng: 'en',
    keySeparator: '.', // We use dot notation for nested translations
    interpolation: {
      escapeValue: false // React already escapes values
    },
    react: {
      useSuspense: false, // Prevents issues during development
    },
    debug: false, // Enable for debug info in console
    returnEmptyString: false, // Don't return empty string if key not found
    returnNull: false, // Don't return null if key not found
  });

// Set language to English and ensure it stays English
i18n.on('languageChanged', () => {
  // Force English if language somehow changes
  if (i18n.language !== 'en') {
    i18n.changeLanguage('en');
  }
  document.documentElement.setAttribute('lang', 'en');
  document.documentElement.dir = 'ltr';
});

// Ensure English is set on initialization
document.documentElement.setAttribute('lang', 'en');
document.documentElement.dir = 'ltr';

export default i18n;
